import { ImportResult, ImportSettings } from "../../shared/model/ImportModel";

import * as FetchActions from "./FetchActions";

import { ThunkResult, Utilities } from "../../shared/utilities";
import { State } from "../model/State";
import { FetchId } from "./FetchActions";

export const IMPORT_PROCESS = "IMPORT_PROCESS";

export async function doImport(file: File, importSettingsWithOptions: ImportSettings[]): Promise<ThunkResult<void, State>> {
    return async (dispatch) => {
        dispatch(FetchActions.fetchStart(FetchId.import));
        const formData = new FormData();
        formData.append("file", file);
        // Only pick the values from importsettins that is needed for the api call.
        const importSettings = importSettingsWithOptions.map((p) => (({ uri, conflictOption }) => ({ uri, conflictOption }))(p));
        formData.append("importSettings", JSON.stringify(importSettings));
        return await Utilities.postForm("api/import/ImportFile", formData)
            .then(Utilities.parseJsonResponse)
            .then((result: ImportResult) => {
                dispatch(FetchActions.fetchFinish(FetchId.import));
                if (result.successful) {
                    Utilities.toastSuccess(result.message);
                    return dispatch(FetchActions.fetchProcesses());
                } else {
                    Utilities.toastError(result.message);
                }
            })
            .catch(((error) => {
                Utilities.toastError(error.message);
                return dispatch(FetchActions.fetchProcesses());
            }));
    };
}
